import type { BitbucketImportedUser } from '@kirin/api-client/contracts/bitbucket';
import type { GithubImportedUser } from '@kirin/api-client/contracts/github';

export type ImportedUser = GithubImportedUser | BitbucketImportedUser;

export interface ImportedUserDisplay {
  displayName: string;
  avatarUrl: string | null | undefined;
  email: string | null | undefined;
  fallbackHandle: string;
  provider: ImportedUser['provider'];
}

export function getImportedUserDisplay(
  user: ImportedUser
): ImportedUserDisplay {
  if (user.provider === 'github') {
    const d = user.providerUserData;
    return {
      displayName: d.name || d.login || '',
      avatarUrl: d.avatarUrl,
      email: d.ssoEmail || d.email,
      fallbackHandle: d.login,
      provider: 'github',
    };
  } else if (user.provider === 'bitbucket') {
    const d = user.providerUserData;
    return {
      displayName: d.displayName || d.nickname,
      avatarUrl: d.avatarUrl,
      email: d.email,
      fallbackHandle: d.nickname,
      provider: 'bitbucket',
    };
  }
  const _exhaustive: never = user;
  throw new Error(
    `Unhandled provider: ${(_exhaustive as ImportedUser).provider}`
  );
}
